import React from 'react';

import { useRecoilValue } from 'recoil';
import { Backdrop, CircularProgress } from '@mui/material';
import { LoadingState } from '@atom/LoadingState';



const Loading: React.FC = () => {
  const loading = useRecoilValue(LoadingState);

  return (
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
      <CircularProgress color="inherit" />
    </Backdrop>

  )
};

export default Loading;
